import React, {useEffect} from 'react';
import {cleanUnderScore} from '../../EditProcess/utils';
import {detectPreviewArrow} from '../../../../../assets/images/images';
import {useRuleLists} from '../hooks/useRuleLists';
import {operatorMaps} from '../../utils';
import {separateCamelCaseWithCaps} from '../../../../../helpers';
import {formatAmount} from '../../../../../components/SmartInput';

export const ConditionPreview = ({
  condition,
  condIndex,
  group,
  rule,
  setListLoading = () => {},
}) => {
  const {currentList, ruleListsLoading} = useRuleLists({
    ruleId: rule?.ruleId,
    value: condition?.value,
    conditionId: condition?.id,
  });

  useEffect(() => {
    if (ruleListsLoading) {
      setListLoading(ruleListsLoading);
    } else {
      setListLoading(false);
    }
  }, [ruleListsLoading, setListLoading]);

  const stringValue = condition?.value?.toString() || '';

  return (
    <React.Fragment>
      <div className="flex items-center bg-[#fefefe] relative border min-w-[120px] w-max text-[#858DAA] min-h-[36px] rounded-lg border-[#dce1e9] pr-2 pl-3 py-2 rounded-r-md transition-all duration-200">
        <div className="flex items-center">
          <div className="w-[5px] h-full rounded-r-lg absolute bg-brandBlue left-[-1px] rounded-full mr-2"></div>
          <p className="text-sm capitalize flex items-center gap-2">
            {cleanUnderScore(condition.field)}

            {operatorMaps(condition.operator) !== undefined ? (
              <span className="text-lg">
                {operatorMaps(condition.operator)}
              </span>
            ) : (
              <span>
                {separateCamelCaseWithCaps(cleanUnderScore(condition.operator))}
              </span>
            )}

            {Array.isArray(condition.value)
              ? currentList?.name
              : cleanUnderScore(
                  !isNaN(stringValue) ? formatAmount(stringValue) : stringValue,
                )}
          </p>
        </div>
      </div>
      {condIndex < group.conditions.length - 1 && (
        <div className="flex items-center justify-center m-[1px]">
          <img
            src={detectPreviewArrow}
            alt="Arrow"
            className={
              group.conditionType === 'or' ? 'transform rotate-[270deg]' : ''
            }
          />
        </div>
      )}
    </React.Fragment>
  );
};
